import { MutableRefObject, useCallback, useEffect, useState } from 'react'
import { IHuddleInvite } from '@common/interfaces/huddles'
import { HuddleSession } from '../helpers/huddle/huddleSession'
import { huddleStore } from '../helpers/huddle/huddleStore'

/** How long an invite stays on screen before it's taken as missed. */
const INVITE_RINGS_FOR_MS = 60 * 1000

interface IHuddleInvites {
  /** Someone asked you into their huddle; null once answered, dismissed or stale. */
  pendingInvite: IHuddleInvite | null
  dismissInvite: () => void
}

/** Rings from others, minus the huddle this tab is already in. */
const useHuddleInvites = (sessionRef: MutableRefObject<HuddleSession | null>): IHuddleInvites => {
  const [pendingInvite, setPendingInvite] = useState<IHuddleInvite | null>(null)
  const dismissInvite = useCallback(() => setPendingInvite(null), [])

  useEffect(
    () =>
      huddleStore.onInvite((incoming) => {
        if (sessionRef.current?.getSnapshot().huddle?.id === incoming.huddleId) return
        setPendingInvite(incoming)
      }),
    [sessionRef],
  )

  useEffect(() => {
    if (!pendingInvite) return undefined
    const timer = setTimeout(() => setPendingInvite(null), INVITE_RINGS_FOR_MS)
    return () => clearTimeout(timer)
  }, [pendingInvite])

  return { pendingInvite, dismissInvite }
}

export default useHuddleInvites
